// extracted by mini-css-extract-plugin
export default {"container":"Cba-z","creativeContainer":"Dba-z","copy":"Eba-z","cta":"Fba-z","disabled":"Gba-z","flipped":"Hba-z","productCard":"Iba-z"};